(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-accordion"] && !Shopify.designMode) return;
  try {
    // Ensures the tab's content is actually visible after opening - on a
  // small viewport (or a tab opened low on the page) the panel can render
  // past the bottom of the screen, or its summary can end up tucked behind
  // the sticky header if the page was already scrolled. Offsets by
  // --site-header-height/--announcement-bar-height (set by
  // sections/header.liquid) rather than the fixed scroll-mt-[10px] class,
  // since the sticky header's real height varies.
  document.querySelectorAll('[data-product-accordion] > details.accordion-item').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;

      requestAnimationFrame(() => {
        const rootStyle = getComputedStyle(document.documentElement);
        let offset = parseFloat(rootStyle.getPropertyValue('--site-header-height')) || 0;
        if (document.body.classList.contains('has-sticky-header')) {
          offset += parseFloat(rootStyle.getPropertyValue('--announcement-bar-height')) || 0;
        }

        const rect = details.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        if (rect.top < offset) {
          // Summary is hidden behind the header - reveal it.
          window.scrollBy({ top: rect.top - offset, behavior: 'smooth' });
        } else if (rect.bottom > viewportHeight) {
          // Panel overflows the bottom of the screen - scroll down just
          // enough to bring it into view, but never past the point where
          // the summary itself would go back under the header (a panel
          // taller than the viewport keeps its summary visible instead).
          const roomAboveHeader = rect.top - offset;
          const scrollAmount = Math.min(rect.bottom - viewportHeight, roomAboveHeader);
          if (scrollAmount > 0) {
            window.scrollBy({ top: scrollAmount, behavior: 'smooth' });
          }
        }
      });
    });
  });

  document.querySelectorAll('[data-product-accordion][data-enable-analytics="true"] details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open || typeof window.gtag !== 'function') return;
      const label = details.querySelector('strong');
      window.gtag('event', 'accordion_open', {
        category: 'PDP Accordion',
        target: label ? label.textContent.trim() : '',
      });
    });
  });

  document.querySelectorAll('[data-proud-to-be]').forEach((wrapper) => {
    const list = wrapper.querySelector('[data-proud-to-be-list]');
    const thumb = wrapper.querySelector('[data-proud-to-be-thumb]');
    if (!list) return;

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    const endDrag = () => {
      isDown = false;
      list.classList.remove('is-dragging');
    };

    list.addEventListener('mousedown', (event) => {
      isDown = true;
      startX = event.pageX;
      startScrollLeft = list.scrollLeft;
      list.classList.add('is-dragging');
    });
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('mousemove', (event) => {
      if (!isDown) return;
      event.preventDefault();
      list.scrollLeft = startScrollLeft - (event.pageX - startX) * 1.5;
    });

    if (thumb) {
      const updateThumb = () => {
        const overflow = list.scrollWidth - list.offsetWidth;
        const thumbWidth = Math.min(100, (list.offsetWidth / list.scrollWidth) * 100);
        const progress = overflow > 0 ? list.scrollLeft / overflow : 0;
        thumb.style.width = `${thumbWidth}%`;
        thumb.style.left = `${progress * (100 - thumbWidth)}%`;
      };
      list.addEventListener('scroll', updateThumb);
      window.addEventListener('resize', updateThumb);
      updateThumb();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-article-list"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-article-list]').forEach((wrapper) => {
    const track = wrapper.querySelector('[data-product-article-list-track]');
    const thumb = wrapper.querySelector('[data-product-article-list-thumb]');
    if (!track) return;

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let dragDistance = 0;

    const endDrag = () => {
      isDown = false;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('mousedown', (event) => {
      // Without this, the browser starts its own native image-drag
      // operation (images are draggable by default) instead of a plain
      // click-drag, and that swallows the mousemove events below.
      event.preventDefault();
      isDown = true;
      dragDistance = 0;
      startX = event.pageX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('mousemove', (event) => {
      if (!isDown) return;
      event.preventDefault();
      const delta = event.pageX - startX;
      dragDistance = Math.max(dragDistance, Math.abs(delta));
      track.scrollLeft = startScrollLeft - delta * 1.5;
    });

    // The browser still fires a plain `click` on whatever's under the
    // cursor at mouseup, no matter how far the drag travelled in between -
    // without this, releasing a drag over an article card silently
    // navigates to it. Only swallow the click once the drag actually moved
    // past a small jitter threshold, so a genuine tap/click still works.
    track.addEventListener('click', (event) => {
      if (dragDistance > 5) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    if (thumb) {
      const updateThumb = () => {
        const overflow = track.scrollWidth - track.offsetWidth;
        const thumbWidth = Math.min(100, (track.offsetWidth / track.scrollWidth) * 100);
        const progress = overflow > 0 ? track.scrollLeft / overflow : 0;
        thumb.style.width = `${thumbWidth}%`;
        thumb.style.left = `${progress * (100 - thumbWidth)}%`;
      };
      track.addEventListener('scroll', updateThumb);
      window.addEventListener('resize', updateThumb);
      updateThumb();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-routine"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-routine]').forEach((wrapper) => {
    const track = wrapper.querySelector('[data-product-routine-track]');
    const thumb = wrapper.querySelector('[data-product-routine-thumb]');
    if (!track) return;

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let dragDistance = 0;

    const endDrag = () => {
      isDown = false;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('mousedown', (event) => {
      // Without this, the browser starts its own native image-drag
      // operation (images are draggable by default) instead of a plain
      // click-drag, and that swallows the mousemove events below.
      event.preventDefault();
      isDown = true;
      dragDistance = 0;
      startX = event.pageX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('mousemove', (event) => {
      if (!isDown) return;
      event.preventDefault();
      const delta = event.pageX - startX;
      dragDistance = Math.max(dragDistance, Math.abs(delta));
      track.scrollLeft = startScrollLeft - delta * 1.5;
    });

    // The browser still fires a plain `click` on whatever's under the
    // cursor at mouseup, no matter how far the drag travelled in between -
    // without this, releasing a drag over a product card silently navigates
    // to it. Only swallow the click once the drag actually moved past a
    // small jitter threshold, so a genuine tap/click on a card still works.
    track.addEventListener('click', (event) => {
      if (dragDistance > 5) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    if (thumb) {
      const updateThumb = () => {
        const overflow = track.scrollWidth - track.offsetWidth;
        const thumbWidth = Math.min(100, (track.offsetWidth / track.scrollWidth) * 100);
        const progress = overflow > 0 ? track.scrollLeft / overflow : 0;
        thumb.style.width = `${thumbWidth}%`;
        thumb.style.left = `${progress * (100 - thumbWidth)}%`;
      };
      track.addEventListener('scroll', updateThumb);
      window.addEventListener('resize', updateThumb);
      updateThumb();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
